import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard, PageResolverService } from '@app/core';
import { PageComponent } from './page/page.component';


const routes: Routes = [
    {
        path: 'page/:id',
        component: PageComponent,
        canActivate: [AuthGuard],
        resolve: {
            page: PageResolverService
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PageRoutingModule { }
